// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseElement } from './BaseElement';
import { EnumComponentType } from '../../../../../com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { APP } from '../../../../../com/MetaPattern/MDA/MD/Base/APP';
import { Product } from '../../../../../com/MetaPattern/MDA/MD/Base/Product';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 组件基类 实体类
 * 所有组件的基类
 */
export abstract class BaseComponent extends BaseElement {
  /** 根名字空间 : 根名字空间 */
  private _rootNamespace: string;

  /** 设置：根名字空间 */
  public get rootNamespace() {
    return this._rootNamespace;
  }

  /** 获取：根名字空间 */
  public set rootNamespace(value: string) {
    this._rootNamespace = value;
  }

  /** 简称 : 组件简称，定义持久化时候实体的前缀，全局唯一 */
  private _alias: string;

  /** 设置：简称 */
  public get alias() {
    return this._alias;
  }

  /** 获取：简称 */
  public set alias(value: string) {
    this._alias = value;
  }

  /** 组件类型 : 组件类型 */
  private _componentType: EnumComponentType;

  /** 设置：组件类型 */
  public get componentType() {
    return this._componentType;
  }

  /** 获取：组件类型 */
  public set componentType(value: EnumComponentType) {
    this._componentType = value;
  }

  /** 版本 : 版本，采用四段结构：主版本号.子版本号[.修正版本号[.编译版本号]] */
  private _version: string;

  /** 设置：版本 */
  public get version() {
    return this._version;
  }

  /** 获取：版本 */
  public set version(value: string) {
    this._version = value;
  }

  /** 所属应用 的ID */
  private _aPP_ID: string;

  /** 获取：所属应用 的ID */
  public get aPP_ID() {
    return this._aPP_ID;
  }

  /** 设置：所属应用 的ID */
  public set aPP_ID(value: string) {
    this._aPP_ID = value;
  }

  /** 所属应用  */
  private _aPP: APP;

  /** 获取：所属应用  */
  public get aPP() {
    return this._aPP;
  }

  /** 设置：所属应用  */
  public set aPP(value: APP) {
    this._aPP = value;
    if (value !== null) {
      this.aPP_ID = value.id;
    } else {
      this.aPP_ID = '';
    }
  }

  /** 所属产品 的ID */
  private _product_ID: string;

  /** 获取：所属产品 的ID */
  public get product_ID() {
    return this._product_ID;
  }

  /** 设置：所属产品 的ID */
  public set product_ID(value: string) {
    this._product_ID = value;
  }

  /** 所属产品  */
  private _product: Product;

  /** 获取：所属产品  */
  public get product() {
    return this._product;
  }

  /** 设置：所属产品  */
  public set product(value: Product) {
    this._product = value;
    if (value !== null) {
      this.product_ID = value.id;
    } else {
      this.product_ID = '';
    }
  }

  constructor() {
    super();
    this._rootNamespace = '';
    this._alias = '';
    this._componentType = EnumComponentType.BE;
    this._version = '0.1.0.0';
    this._aPP_ID = '';
    this._aPP = null;
    this._product_ID = '';
    this._product = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: BaseComponent, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.rootNamespace = element.rootNamespace;
      this.alias = element.alias;
      this.componentType = element.componentType;
      this.version = element.version;
      this.aPP_ID = element.aPP_ID;
      if (hasReference && element.aPP !== null) {
        this.aPP = element.aPP;
      }
      this.product_ID = element.product_ID;
      if (hasReference && element.product !== null) {
        this.product = element.product;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.rootNamespace = json.RootNamespace;
    this.alias = json.Alias;
    this.componentType = json.ComponentType as EnumComponentType;
    this.version = json.Version;
    this.aPP_ID = json.APP_ID;
    // if (json.APP !== null) {
    //   this.aPP = APP.Create(json.APP);
    // }
    this.product_ID = json.Product_ID;
    // if (json.Product !== null) {
    //   this.product = Product.Create(json.Product);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.RootNamespace = this.rootNamespace;
    json.Alias = this.alias;
    json.ComponentType = this.componentType;
    json.Version = this.version;
    json.APP_ID = this.aPP_ID;
    json.Product_ID = this.product_ID;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
    context.addRow('基本属性', 'rootNamespace', '根名字空间', EnumDataType.String, this.rootNamespace, true, '根名字空间', '', '');
    context.addRow('基本属性', 'alias', '简称', EnumDataType.String, this.alias, true, '组件简称，定义持久化时候实体的前缀，全局唯一', '', '');
    context.addRow('基本属性', 'componentType', '组件类型', EnumDataType.Reference, this.componentType, false, '组件类型', 'EnumComponentType', 'PGRowEnumValue');
    context.addRow('基本属性', 'version', '版本', EnumDataType.String, this.version, true, '版本，采用四段结构：主版本号.子版本号[.修正版本号[.编译版本号]]', '', '');
  }
}
